import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/delivery.scss";

function Delivery() {
  return (
    <div className="delivery">
      <Header />

      <main className="delivery-main">
        <div className="page-hero">
          <h1>Shipping Information</h1>
          <p>Everything you need to know about getting your Parkhaven gear.</p>
        </div>

        <div className="delivery-content">
          <section className="shipping-methods">
            <h2>Shipping Methods & Costs</h2>
            <p>
              We offer several shipping options to meet your needs. Orders are
              processed and shipped Monday through Friday, excluding holidays.
            </p>

            <div className="methods-table">
              <div className="table-header">
                <div className="col-method">Method</div>
                <div className="col-time">Estimated Delivery</div>
                <div className="col-cost">Cost</div>
              </div>

              <div className="table-row">
                <div className="col-method">
                  <strong>Standard Shipping</strong>
                  <span>(FedEx or USPS)</span>
                </div>
                <div className="col-time">4-6 Business Days</div>
                <div className="col-cost">
                  <strong>FREE</strong> on orders $99+
                  <br />
                  $8.00 for orders under $99
                </div>
              </div>

              <div className="table-row">
                <div className="col-method">
                  <strong>Expedited Shipping</strong>
                  <span>(FedEx 2Day)</span>
                </div>
                <div className="col-time">2 Business Days</div>
                <div className="col-cost">$15.00</div>
              </div>

              <div className="table-row">
                <div className="col-method">
                  <strong>Rush Shipping</strong>
                  <span>(FedEx Standard Overnight)</span>
                </div>
                <div className="col-time">1 Business Day</div>
                <div className="col-cost">$25.00</div>
              </div>
            </div>
          </section>

          <section className="shipping-faq">
            <h2>Frequently Asked Questions</h2>

            <div className="faq-item">
              <h3>When will my order ship?</h3>
              <p>
                Most orders placed before 10:00 AM PT Monday through Friday will
                be processed and shipped the same day. Orders placed after 10:00
                AM PT, or on weekends and holidays, will ship the next business
                day.
              </p>
            </div>

            <div className="faq-item">
              <h3>Do you ship internationally?</h3>
              <p>
                Currently, we only ship to the United States (including Alaska,
                Hawaii, and Puerto Rico) and Canada. We do not ship to P.O.
                Boxes for Expedited or Rush shipping methods.
              </p>
            </div>

            <div className="faq-item">
              <h3>How can I track my order?</h3>
              <p>
                Once your order ships, you will receive a shipping confirmation
                email with a tracking number. You can also track your order by
                logging into your Parkhaven account.
              </p>
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Delivery;
